import React from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { 
  FaUserFriends, 
  FaFileAlt, 
  FaProjectDiagram, 
  FaNewspaper, 
  FaCalendarAlt, 
  FaQuoteRight, 
  FaSignOutAlt,
  FaTachometerAlt
} from 'react-icons/fa';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    navigate('/admin/login');
  };

  const NavItem = ({ to, icon: Icon, label }) => {
    const isActive = location.pathname.startsWith(to);
    return (
      <NavLink 
        to={to} 
        className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 group ${
          isActive 
            ? 'bg-gradient-to-r from-cyan-600 to-blue-600 text-white shadow-lg shadow-cyan-500/30' 
            : 'text-gray-400 hover:bg-white/5 hover:text-white'
        }`}
      >
        <Icon className={`text-lg ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-cyan-400'} transition-colors`} />
        <span className="font-medium text-sm">{label}</span>
      </NavLink>
    );
  };

  return (
    <div className="w-72 bg-[#0f172a] border-r border-white/5 text-white h-screen flex flex-col shadow-2xl z-50">
      <div className="p-8 pb-4">
        <h2 className="text-2xl font-extrabold tracking-tight bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
          TechVelly
        </h2>
        <p className="text-xs text-gray-500 mt-1 uppercase tracking-widest">Admin Dashboard</p>
      </div>

      <div className="flex-1 px-4 py-4 space-y-8 overflow-y-auto custom-scrollbar">
        <div>
          <p className="px-4 text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Management</p>
          <div className="space-y-1">
            <NavItem to="/admin/contacts" icon={FaUserFriends} label="Contacts" />
            <NavItem to="/admin/quotes" icon={FaQuoteRight} label="Quotes" />
          </div>
        </div>

        <div>
          <p className="px-4 text-xs font-bold text-gray-500 uppercase tracking-wider mb-2">Content</p>
          <div className="space-y-1">
            <NavItem to="/admin/projects" icon={FaProjectDiagram} label="Projects" />
            <NavItem to="/admin/blogs" icon={FaFileAlt} label="Blogs" />
            <NavItem to="/admin/news" icon={FaNewspaper} label="News" />
            <NavItem to="/admin/events" icon={FaCalendarAlt} label="Events" />
          </div>
        </div>
      </div>

      <div className="p-4 border-t border-white/5">
        <button 
          onClick={handleLogout} 
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-gray-400 hover:bg-red-500/10 hover:text-red-400 transition-all duration-200"
        >
          <FaSignOutAlt className="text-lg" />
          <span className="font-medium text-sm">Sign Out</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;